import React from "react";
import { useStoreActions, useStoreState } from "easy-peasy";
import { useHistory } from "react-router-dom";
import Wildcard from "../../../../services/wildcard";
import { useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import ValidatorService from "../../../../services/validator";
import TC from "../../add-ons/TC";
import Esign from "../../add-ons/esign";
import marketing from "../../../../services/marketing";
import "../../../../assets/terms/dm-terms.css";
import Acknowledgements from "../../add-ons/Acknowledgements";
import CreditProtection from "../../add-ons/CreditProtection";
import OverlimitPrivilege from "../../add-ons/OverlimitPrivilege";
import { useEffect } from "react";
import ErrorModal from "../../../body/forms/components/ErrorModal";
import InvalidStateModal from "../../global-elements/invalidStateModal";
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PixelsService from '../../../../services/pixels';
import ConfirmSmsConsent from "../../global-elements/confirmsSmsConsent";
import SubmitApplicationService from "../../../../services/submitApplication";
import AddCardholder from "../../global-elements/addCardholder";
import Econsent from '../../global-elements/eConsent';
import AxiosWrapper from "../../../../services/axios";
import MfaSms from "../../global-elements/mfa/mfaSms";
import MfaEmail from "../../global-elements/mfa/mfaEmail";
import DeadEndMFa from "../../global-elements/mfa/deadEndMfa";
import AdobeScript from "../../../../services/adobeScript";
import { InactiveDetection } from "../../../../services/inactiveDetection";
import OutdatedUiVersion from "../../global-elements/outdatedUiVersion";
import { FLOW, PRODUCT } from "../../../../models/websiteTypesConstants";

function Terms() {
  const Setting = useStoreState((state) => state.siteSettingsModel);
  const setGrandBanckDeclined = useStoreActions((actions) => actions.siteSettingsModel.setGrandBanckDeclined);
  const info = useStoreState((state) => state.applicantModel.applicant);
  const setInfo = useStoreActions((actions) => actions.applicantModel.setApplicant);
  const text = useStoreState((state) => state.dmText.terms);
  const setApplicationResult = useStoreActions((actions) => actions.applicationResultModel.setApplicationResult);
  const pendingInfo =  ["FROZEN", "FROZENPREQUAL", "PENDFEE", "PENDFUNDING", "PENDINFO", "PENDINTERNAL"];
  const resultStep = useStoreActions((actions) => actions.setDisplayResult);
  const history = useHistory();
  const wildcard = new Wildcard();
  const validatorService = new ValidatorService();
  const methods = useForm({ mode: "onSubmit" });
  const [isLoading, setLoading] = useState(false);
  const utms = new marketing();
  const [errorShow, setErrorShow] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [showOutdatedUiVersionError, setShowOutdatedUiVersionError] = useState(false);
  const [showInvalidStateModal, setShowInvalidStateModal] = useState(false);
  const closeError = () => setErrorShow(false);
  const [showAdditionalCardHolderForm, setShowAdditionalCardHolderForm] =useState(false);
  const termsPixels = useStoreState(state => state.termsPixels);
  const setTermsPixel = useStoreActions(actions => actions.setTermsPixel);
  const getRoutingSettings = useStoreActions(state => state.routingSettingsModel.getRoutingSettings);
  const PixelService = new PixelsService();
  const submitApplicationService = SubmitApplicationService();
  const setDeclineOffers = useStoreActions(actions => actions.siteSettingsModel.setDeclineOffers);
  const setMfaSms = useStoreActions(actions => actions.setMfaSms);
  const client = new AxiosWrapper()
  const adobeAds = new AdobeScript();
  const [tcHasErrors, setTcHasErrors] = useState(false);
  const showOverlimit = wildcard.isFeatureEnabled('OverlimitSettings');

  InactiveDetection.setInactiveTitle("Make it count! Finish your application");

  useEffect(() => {
    if (!termsPixels) {
      PixelService.pageView("/Terms").event("google","CS","Terms");
      
      setTermsPixel(true)
    }
    getRoutingSettings({ Url: Setting.domain, Route: window.location.pathname});
  },[])

  useEffect(() => {
    const validate = async () => {
        const isValidUiVersion = await validatorService.UiVersionValidate();
        setShowOutdatedUiVersionError(!isValidUiVersion);
    };

    validate();
},[])

  useEffect(() => {
    //unregister controls to avoid validations
    
    if (showAdditionalCardHolderForm===false) {
        methods.unregister(["additionalCardholderFirstName", "additionalCardholderMI", "additionalCardholderLastName", "hasAdditionalCardholder"])
    }
  }, [showAdditionalCardHolderForm]);



  const submit = async (data) => {
    if (showAdditionalCardHolderForm===false) {
      delete data["additionalCardholderFirstName"]
      delete data["additionalCardholderLastName"]
      delete data["additionalCardholderMI"]
    }
    setLoading(true);
    if (!validatorService.preValidations(data, methods, info)) {
      
        if(wildcard.isFeatureEnabled('MFAActive')){
          let mfaId = await client.get('/mfa-id',{})
          sessionStorage.setItem('mfaId', mfaId);
          console.log(mfaId)
          let result = await client.post('/send-Mfa', {
              contactIdentifier : info.PrimaryPhone,
              contactType : 'Text', 
              ApplicantId : 0,
              WebUrl : Setting.domain
              }, true)
          if(result && result.Success === true){
              sessionStorage.setItem('sessionToken', result.Payload)
              setMfaSms(true)
              return
          }
          setErrorShow(true);
          setErrorMessage('An unknown error has occured. Please try again.')
          return
      }else{
        await submitApplication();
    }}
    setLoading(false);
  };

  async function submitApplication() {
   
    let response = await submitApplicationService.submitApplication(info);

    if (response) {
      if (response.result.toUpperCase() === "INVALID_UI_VERSION") {
        setShowOutdatedUiVersionError(true);
        return;    
      }

      setApplicationResult(response);
      if (response.IsGrandbank === true) {
        setGrandBanckDeclined(true);
      }

      if (response.result != null) {

        utms.updateSessionReport("appResult",response.result.toUpperCase());
        utms.updateSessionReport("applicantId", response.ref_number);
        window.cl = response.credit_limit ?? 0;
        setInfo({ index: "step", value: 3 });
        response.decline_message = response.decline_message === "" ? "We are unable to verify your identity." : response.decline_message;
        
        resultStep(true);
        //Decline Offers for BMG box
        setDeclineOffers(response.DeclineOffers || null);

        window.scrollTo(0, 0);
        if (response.result.toUpperCase() === "APPROVED") {
          history.push("/approved" + window.location.search);
          return;
        }
        if (pendingInfo.includes(response.result.toUpperCase())) {
          history.push("/pendinfo" + window.location.search);
          return;
        }
      }
      history.push("/decision" + window.location.search);
      return;
    } else {
      setErrorMessage("An unknown error has occured. Please try again.");
      setErrorShow(true);
      setLoading(false);
    }
  }

  return (
    <>
 {/*--- MFA stuff ---*/}
        {(wildcard.isFeatureEnabled('MFAActive')) && (
              <>
                  <MfaSms />
                  <MfaEmail />
                  <DeadEndMFa />
              </>
              
        )}
      {/*--- END MFA stuff ---*/}
      <div className={("row" + (Setting.brandSettings.ProductName === PRODUCT.Grand.bank ? " ribbonGB" : ""))} id="header-text-container" style={{ backgroundColor: Setting.brandSettings.Primary }}>
        <div className="col-12 text-center">
          <h1 id="offer-header-text" className="mt-2 mb-2">
            {wildcard.proccess(text.block1.title)}
          </h1>
        </div>
      </div>
      <div className="container mt-5 mb-5">
        <ErrorModal size="sm" show={errorShow} message={errorMessage} closeError={closeError} />
        {showOutdatedUiVersionError ?
            <OutdatedUiVersion />
        :
        <>
          <FormProvider {...methods}>
            <form onSubmit={methods.handleSubmit(submit)} >
              <div>
                <div 
                  className="add-authorized-user-text"
                  onClick={() =>
                    setShowAdditionalCardHolderForm(!showAdditionalCardHolderForm)
                  }
                >
                  <span>
                    <FontAwesomeIcon icon={showAdditionalCardHolderForm ? faMinus : faPlus} />
                  </span>
                  Add Authorized User (Optional)
                </div>

                {/* Authorized User Form */}
                {showAdditionalCardHolderForm && (
                  <AddCardholder></AddCardholder>
                )}
              </div>
              <div className="row">
                <div className="col-12">
                  <h1 className="terms-header-title">E-Sign Disclosure</h1>
                </div>
                <Esign />
              </div>
              <div className="row">
                <div className="col-12">
                  <h1 className="terms-header-title">Pricing and Terms</h1>
                </div>
                <div className="col-12 ">
                  <div className="terms-wrapper">
                  <TC data={{ productCode: info.ProductCode }} onTermsErrorChange={setTcHasErrors} />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <h1 className="terms-header-title">Credit Protection</h1>
                </div>
                <CreditProtection />
              </div>
            {showOverlimit && (
              <div className="row">
                <div className="col-12">
                  <h1 className="terms-header-title">Overlimit Privilege</h1>
                </div>
                <OverlimitPrivilege />
              </div>
            )}
              <div className="row">
                <div className="col-12">
                  <h1 className="terms-header-title">Acknowledgements</h1>
                </div>
                <Econsent />
                {Setting.smsConcentModuleCS === true && (
                  <div className="col-12 mb-3">
                      <div className="col-12">
                          <ConfirmSmsConsent></ConfirmSmsConsent>
                      </div>
                  </div>
              )}
                <Acknowledgements data={{ productCode: info.ProductCode }} />
              </div>
              <div className="row mt-3">
                <div className="text-center mx-auto">
                  <button
                    onClick={(e) => {
                      utms.trackEvent(30, "CS", "", Setting.productSettings.ProductId, "Flow");
                      adobeAds.event('form_submit');
                      PixelService.event("google", "CS", "Accept Offer");
                    }}
                    disabled={ isLoading || tcHasErrors }
                    id="dm-submit-app"
                    style={{
                    backgroundColor: Setting.mainSettings.Flow === FLOW.CS ? Setting.brandSettings.Primary : Setting.brandSettings.Secondary
                    }}
                    className="btn text-small mt-3 rounded-pill p-3"
                    type="submit"
                  >
                    {isLoading ? "Submitting..." : (wildcard.isFeatureEnabled('MFAActive') ? 'Verify and Submit' : 'Submit Application') }
                  </button>
                </div>
              </div>
            </form>
          </FormProvider>
        </>}
      </div>

      <InvalidStateModal
        showInvalidStateModal={showInvalidStateModal}
        setShowInvalidStateModal={setShowInvalidStateModal}
      />
    </>
  );
}

export default Terms;
